import { Grid, TextField } from '@mui/material'
import { useAppSelector } from '~/app/hooks'
import { currentTheme } from '~/redux/features'
import { camalize } from '~/utils'
import { EFInputLabel } from '../EFInputLabel'
import { EFHorizontalTextFieldProps } from './EFTextField.model'
import classNames from 'classnames/bind'
import styles from './EFTextField.module.scss'

const cx = classNames.bind(styles)

export function CustomHorizontalTextField(props: EFHorizontalTextFieldProps) {
  const theme = useAppSelector(currentTheme)
  const { labelWidth = 2, ...otherProps } = props
  return (
    <Grid
      paddingBottom={1}
      container
      spacing={2}
      alignItems='center'
    >
      <Grid
        item
        xs={labelWidth}
        md={labelWidth}
      >
        {props.label && (
          <EFInputLabel
            label={props.label}
            name={props.name}
            sx={props.labelSx}
          />
        )}
      </Grid>
      <Grid
        item
        xs={12 - labelWidth}
        md={12 - labelWidth}
      >
        <TextField
          {...otherProps}
          className={cx('text-field', theme)}
          autoComplete='new-password'
          type={props.type}
          name={props.name}
          value={props.value ?? ''}
          placeholder={props.placeholder}
          id={camalize(props.name)}
          InputLabelProps={{ sx: { display: 'none' }, shrink: false }}
        />
      </Grid>
    </Grid>
  )
}
